import { api } from '@api'

// Supabase signs for 60m; keep data fresh for ~55m
const SIGNED_URL_SECONDS = 60 * 60
const STALE_TIME_MS = 55 * 60 * 1000

export async function fetchImageUrl(id?: string): Promise<string | null> {
  if (!id) return null

  // We now strictly assume .webp thanks to client-side compression
  const path = `${id}.webp`

  const { data, error } = await api()
    .storage.from('profile-images')
    .createSignedUrl(path, SIGNED_URL_SECONDS)

  // Supabase signed URLs always contain a ?token= parameter.
  // We append a timestamp to bust the browser's disk cache whenever this runs.
  // Since TanStack Query caches the result for 55m, this won't spam the network
  // unless we explicitly invalidate the query!
  return !error && data?.signedUrl ? `${data.signedUrl}&v=${Date.now()}` : null
}

// Query opts factory
export const avatarQueryOpts = (id?: string) => ({
  queryKey: ['avatarUrl', id],
  enabled: !!id,
  queryFn: () => fetchImageUrl(id),
  staleTime: STALE_TIME_MS,
  gcTime: 2 * 60 * 60 * 1000, // keep in cache for 2h
  refetchOnWindowFocus: false,
  retry: 1,
})
